module.exports = __webpack_public_path__ + "static/media/eye.3a51f187.svg";